// Function responsible for preparing and structuring time_on_page event data
export var prepareEventData = function prepareEventData(data, force) {
  var event = {
    type: 'time_on_page',
    version: 1,
    data: data
  };
  if (force) {
    event.options = {
      force: force
    };
  }
  return event;
};
export default prepareEventData;